import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "hylas_token";
const USER_KEY = "hylas_user";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => { localStorage.removeItem(TOKEN_KEY); localStorage.removeItem(USER_KEY); };
export const getUser = () => { try { return JSON.parse(localStorage.getItem(USER_KEY) || "null"); } catch { return null; } };
export const setUser = (u) => localStorage.setItem(USER_KEY, JSON.stringify(u));

const client = axios.create({ baseURL: API });
client.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const login = (email, password) => client.post("/auth/login", { email, password });
export const logoutApi = () => client.post("/auth/logout").catch(() => {});
export const getMe = () => client.get("/auth/me");
export const listUsers = () => client.get("/users");
export const changeUserPassword = (id, password) => client.post(`/users/${id}/password`, { password });
export const getConfig = () => client.get("/config");
export const getLeads = () => client.get("/leads");
export const getLeaderboardDataset = () => client.get("/leaderboard-dataset");
export const getStats = () => client.get("/stats");
export const syncLeads = () => client.post("/sync");
export const setStage = (id, stage, undo = false) => client.patch(`/leads/${id}/stage`, { stage, undo });
export const setTag = (id, tag, on) => client.patch(`/leads/${id}/tags`, { tag, on });
export const setEmail = (id, email) => client.patch(`/leads/${id}/email`, { email });
export const addNote = (id, text) => client.post(`/leads/${id}/note`, { text });
export const setCallback = (id, callback_at) => client.patch(`/leads/${id}/callback`, { callback_at });
export const setArchived = (id, archived) => client.patch(`/leads/${id}/archive`, { archived });
export const getPayments = () => client.get("/payments");
export const updatePayment = (id, body) => client.patch(`/payments/${id}`, body);
export const setPaymentPart = (id, part, paid) => client.patch(`/payments/${id}/parts/${part}`, { paid });
export const setLateFee = (id, part, amount, note) => client.patch(`/payments/${id}/parts/${part}/fee`, { amount, note });
export const downloadStatement = async (carrier) => {
  const res = await client.get("/payments/statement", { params: { carrier }, responseType: "blob" });
  const name = /filename="([^"]+)"/.exec(res.headers["content-disposition"] || "")?.[1] || "statement.pdf";
  const url = URL.createObjectURL(res.data);
  const a = Object.assign(document.createElement("a"), { href: url, download: name });
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};
export const sendInvoice = (id, part) => client.post(`/payments/${id}/invoice/${part}`);
export const setPin = (id, pinned) => client.patch(`/leads/${id}/pin`, { pinned });

export default client;
